// gallery.js

const galleryList = document.querySelector('.block--gallery__container__list');

function initGallery() {

	if (!galleryList) return;

	Fancybox.bind('.block--gallery__container__list .fancybox', {
		// options here
	});
}

initGallery();